const READY_POLL_INTERVAL_MS = 50;
const READY_TIMEOUT_MS = 10000;

/**
 * `window.Stripe` is the factory supplied by js.stripe.com. The tag that loads it sits
 * below app.js in the layout, so anything running on boot has to wait for it.
 *
 * The instance built from this factory lives on `window.stripeInstance` — the factory
 * itself is deliberately left untouched because Churnkey's SDK calls `window.Stripe()`.
 */
export const waitForStripe = () => new Promise((resolve, reject) => {
  if (typeof window.Stripe === 'function') {
    resolve();
    return;
  }

  const startedAt = Date.now();

  const poll = setInterval(() => {
    if (typeof window.Stripe === 'function') {
      clearInterval(poll);
      resolve();
      return;
    }

    if (Date.now() - startedAt >= READY_TIMEOUT_MS) {
      clearInterval(poll);
      reject(new Error('Timed out waiting for Stripe.js to load'));
    }
  }, READY_POLL_INTERVAL_MS);
});
